// extracted by mini-css-extract-plugin
export var card = "_6e-0";
export var expandedCard = "_6e-2";
export var paginated = "_6e-1";